import { Box } from '@mui/material';
import { AutomationDialogContent } from '../../../../Automations/AutomationDialogContent';
import { AutomationFormVariant } from '../../../../../types/enums/AutomationFormVariant';
import useAutomationApiPerType from '../../../../Automations/useAutomationApiPerType';
import { useSelector } from 'react-redux';
import { selectDefaultCreationEnvironment } from '../../../environments/environmentsReducer';
import { assignmentsSortOptions, automationsSortOptions } from '../../../../Automations/consts';
import usePaywall from '../../../../dashboard/paywall/usePaywall';
import PaywallVerticalLayout from '../../../../dashboard/paywall/sales-activated-trial/PaywallVerticalLayout';
import { getPaywallSourceFromAutomationVariant } from '../../../../dashboard/paywall/sales-activated-trial/helper';
import { useGetAutomationFilters } from '../../../../Automations/filters/helpers';

interface RightPanelAutomationsTabProps {
  readonly?: boolean;
  funnelDetails: FunnelDetails;
  automationVariant: AutomationFormVariant;
  automations?: AutomationStructureNew[];
  onCreateData?: { newElement: Partial<AutomationStructureNew> };
}

export const RightPanelAutomationsTab = ({
  funnelDetails,
  automationVariant,
  automations,
  onCreateData,
}: RightPanelAutomationsTabProps) => {
  const { isPaywallActive } = usePaywall();
  const paywallSource = getPaywallSourceFromAutomationVariant(automationVariant);

  const defaultCreationEnvironment = useSelector(selectDefaultCreationEnvironment);
  const crmOrgId = defaultCreationEnvironment?.id;
  const { onSaveOrCreate, onToggleActivation, onDeleteAutomation, onDeployAutomation } =
    useAutomationApiPerType({
      automationVariant,
    });

  const filters = useGetAutomationFilters({
    automations: automations ?? [],
    crmOrgId: crmOrgId ?? '',
  });

  return (
    <Box flex={1} height="100%">
      {isPaywallActive && <PaywallVerticalLayout variant="wide" paywallSource={paywallSource} />}
      {crmOrgId && !isPaywallActive && (
        <AutomationDialogContent
          onSaveOrCreate={onSaveOrCreate}
          onToggleActivation={onToggleActivation}
          onDeleteAutomation={onDeleteAutomation}
          automations={automations ?? []}
          crmOrgId={crmOrgId}
          sortOptions={
            automationVariant === AutomationFormVariant.ASSIGNMENT_RULES
              ? assignmentsSortOptions
              : automationsSortOptions
          }
          disableCanvasTemplates
          onCreateData={onCreateData}
          objectType={funnelDetails.leadingObject.objectName}
          hideSort={true}
          disableExpandedMode={true}
          onDeployAutomation={onDeployAutomation}
          isShowWideScreenPopup={true}
          filters={filters}
        />
      )}
    </Box>
  );
};
